// src/pages/BookClass.js
import React, { useEffect } from "react";
import Offerings from "../components/Offerings";
import PricingCard from "../components/PricingCard";
import PaymentInfo from "../components/PaymentInfo";
import CalendarBookingView from "./CalendarBookingView";

const BookClass = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  return (
    <div>
      <div className="rates-format">
        <h1>Enjoy booking! Book by clicking <br/> on selected
        dates (blue tiles) where slots are available. </h1>
        {/* <PricingCard /> */}
        {/* <PaymentInfo /> */}
        <CalendarBookingView />
      </div>
    </div>
  );
};

export default BookClass;
